import { connect } from 'react-redux';

import PayOneTimePaymentPage from './component';
import TransactionConstants from '@common/constants/TransactionConstants';
import ONE_TIME_PAYMENT_TYPE from '@common/constants/oneTimePaymentTypes';
import { getVerifiedPaymentMethods } from '@common/paymentsUtils/multiplePaymentMethodsUtil';
import type { OneTimeRenterPaymentWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

const findOneTimePaymentTransaction = (decodedKey, transactions) => {
  const unpaidFailedRegex = `${TransactionConstants.STATUS.UNPAID}|${TransactionConstants.STATUS.PAYMENT_FAILED}`;
  return transactions
    .filter((transaction) => transaction.paymentCategory === TransactionConstants.CATEGORY.ONE_TIME_PAYMENT)
    .filter((transaction) =>
      transaction.paymentType === ONE_TIME_PAYMENT_TYPE.PAYMENT_PLAN
        ? String(transaction.requestKey) === decodedKey
        : String(transaction.groupKey) === decodedKey,
    )
    .filter((transaction) => transaction.renterStatus.match(new RegExp(unpaidFailedRegex)))
    .pop();
};

const mapStateToProps = (state, { otpKey, failedPaymentEmail }) => {
  const { transactions } = state.payments.renter.dashboard.paymentHistory;
  const { landlordProfile, paymentDetails } = state.payments.renter.dashboard;
  const decodedKey = decodeURI(otpKey);
  const transaction = findOneTimePaymentTransaction(decodedKey, transactions);
  const verifiedPaymentMethods = getVerifiedPaymentMethods(state.payments.renter.dashboard.paymentMethods);
  return {
    user: state.user,
    transaction,
    landlordName: landlordProfile.name,
    landlordFirstName: landlordProfile.firstName,
    accountLast4: paymentDetails.accountLast4,
    accountName: paymentDetails.accountName,
    failedPaymentEmail,
    paymentMethods: verifiedPaymentMethods,
  };
};

type PayOneTimePaymentPageOwnProps = {
  baseUrl?: string;
  propertyId?: string | undefined;
  otpKey?: string;
  failedPaymentEmail?: boolean;
};

const buildPaymentPayload = (
  paymentType: string,
  groupKey: string,
  requestKey: string,
  selectedPaymentMethodId: string,
): OneTimeRenterPaymentWebApiRequestDto => {
  if (paymentType === ONE_TIME_PAYMENT_TYPE.PAYMENT_PLAN) {
    return {
      externalGroupKey: undefined,
      externalRequestKey: requestKey,
      externalPaymentMethodId: selectedPaymentMethodId,
    };
  }
  return {
    externalGroupKey: groupKey,
    externalRequestKey: undefined,
    externalPaymentMethodId: selectedPaymentMethodId,
  };
};

const mergeProps = (
  stateProps: Record<string, unknown>,
  _dispatchProps: Record<string, unknown>,
  ownProps: PayOneTimePaymentPageOwnProps,
) => {
  const transaction = stateProps.transaction as
    | { paymentType: string; requestKey: string; groupKey: string; paymentPlanInstallmentTitle?: string }
    | undefined;
  const paymentType = transaction?.paymentType ?? '';
  const requestKey = transaction?.requestKey ?? '';
  const groupKey = transaction?.groupKey ?? '';
  const paymentPlanInstallmentTitle = transaction?.paymentPlanInstallmentTitle;

  return {
    ...stateProps,
    ...ownProps,
    paymentPlanInstallmentTitle,
    getPaymentPayload: (selectedPaymentMethodId: string) =>
      buildPaymentPayload(paymentType, groupKey, requestKey, selectedPaymentMethodId),
  };
};

export default connect(mapStateToProps, () => ({}), mergeProps)(PayOneTimePaymentPage);
